
import { Options, Vue }    from 'vue-class-component';
import AddonCard from '../components/shared/addon-card.vue'
import { chain, keyBy, mapValues } from 'lodash'

@Options({
  components: {
    AddonCard
  },
  data() {
    return {
      items: this.$store.state.addons
    }
  },
  watch: {
    items:{
      handler:function(newVal) {
        this.$store.commit('setAddons', newVal);
      },
      deep:true
    }
  }
})
export default class Addons extends Vue {
  items: { key: string; title: string; attributes: ({ key: string; value: string; } | { key: string; value: number; })[]; price: string; media: any; }[];
  mounted(){
    const productRes = this.$store.state.addons || this.$store.state.responseAddons.map(x=> ({
      id: x._id,
      key: x.key,
      title: x.name,
      attributes: chain(x.propertyAttributes).keyBy('key').mapValues('value').value(),
      price: x.priceUnit ? `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} € / ${x.priceUnit}` : `${(x.estimatedPrice.retailPriceWithDiscount || x.estimatedPrice.retailPrice).toFixed(2)} €`,
      priceWithoutDiscount: x.priceUnit ? `${x.estimatedPrice.retailPrice.toFixed(2)} € / ${x.priceUnit}` : `${x.estimatedPrice.retailPrice.toFixed(2)} €`,
      discount: x.estimatedPrice.retailPriceDiscount?.value > 0 ? true : false,
      thumbnail: x.metadata.thumbnail,
      priceUnit: x.priceUnit
    }));

    this.items = productRes;
  }
}
